import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["aria-pressed", "disabled"]
const _hoisted_2 = {
  key: 0,
  class: "inline-flex flex-shrink-0 items-center justify-center text-catering-ink-900"
}
const _hoisted_3 = { class: "flex min-w-0 flex-1 flex-col gap-0.5" }
const _hoisted_4 = {
  key: 0,
  width: "13",
  height: "13",
  viewBox: "0 0 14 14",
  fill: "none"
}


export default {
  __name: 'OptionCard',
  props: {
  selected: { type: Boolean, default: false },
  sel: { type: String, default: 'check' },
  align: { type: String, default: 'horizontal' },
  disabled: { type: Boolean, default: false },
  loading: { type: Boolean, default: false }
},
  emits: ['click'],
  setup(__props) {




return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    "aria-pressed": __props.selected,
    disabled: __props.disabled,
    class: _normalizeClass(["relative w-full text-left flex transition-all duration-150 border-[1.5px] rounded-catering-lg", [
      __props.align === 'vertical' ? 'flex-col items-start gap-3 p-5' : 'flex-row items-center gap-4 px-[18px] py-4',
      __props.selected
        ? 'bg-catering-lemon-100 border-catering-ink-900 shadow-catering-sm'
        : 'bg-catering-cream-50 border-catering-cream-500 shadow-catering-xs hover:border-catering-ink-300 hover:shadow-catering-sm hover:-translate-y-px',
      __props.disabled && 'opacity-55 cursor-not-allowed'
    ]]),
    onClick: _cache[0] || (_cache[0] = $event => (!__props.disabled && _ctx.$emit('click')))
  }, [
    (_ctx.$slots.icon)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
          _renderSlot(_ctx.$slots, "icon")
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("span", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    (__props.loading)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["inline-flex h-[22px] w-[22px] flex-shrink-0 animate-spin rounded-full border-2 border-catering-ink-300 border-t-transparent", __props.align === 'vertical' && 'absolute right-[18px] top-[18px]'])
        }, null, 2))
      : (__props.sel !== 'none')
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            class: _normalizeClass(["inline-flex flex-shrink-0 items-center justify-center border-[1.5px] transition-all duration-150", [
        __props.sel === 'radio' ? 'rounded-full' : 'rounded-catering-xs',
        __props.selected ? 'border-catering-ink-900 bg-catering-ink-900' : 'border-catering-cream-500 bg-transparent',
        __props.align === 'vertical' ? 'absolute right-[18px] top-[18px] h-[22px] w-[22px]' : 'h-[22px] w-[22px]'
      ]])
          }, [
            (__props.selected)
              ? (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("path", {
                    d: "M2.5 7.5L5.5 10.5L11.5 3.5",
                    stroke: "#FDFF74",
                    "stroke-width": "2.2",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, null, -1)
                ]))]))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

}